module.exports = __webpack_public_path__ + "static/InterstateBlackCondensed-48b519ec8aab0e1ffdf33e5cee39ff0d.woff2";